<template>
    <div id="scroll-board">
        <div class="topbox">
            <el-row class="itemrow">
                <el-col v-for="(tl, index) in header" :span="tl.width" :key="index">
                    <div class="text">{{ tl.title }}</div>
                </el-col>
            </el-row>
            <el-carousel style="width: 26vw; height: 26.5vh;" direction="vertical" :autoplay="true"
                indicator-position="none" @change="pageChange">
                <el-carousel-item v-for="(page, index) in pageData" :key="index">
                    <el-row v-for="(item, index) in page.arr" :key="index" class="datarow">
                        <el-col :span="4" style="display: flex;align-items: center;justify-content: center;">
                            <div v-if="item.index == 1" class="sort_first"></div>
                            <div v-else-if="item.index == 2" class="sort_sec"></div>
                            <div v-else-if="item.index == 3" class="sort_thr"></div>
                            <div v-else class="text">{{ item.index }}</div>

                        </el-col>
                        <el-col :span="8" style="display: flex;flex-direction: row;">
                            <div class="text">{{ item.name }}</div>
                            <div v-if="item.change > 0" class="red">↑{{ item.change }}</div>
                            <div v-if="item.change < 0" class="green">↓{{ item.change * -1 }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="text">{{ item.amount }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="text">{{ item.Persent }}%</div>
                        </el-col>
                    </el-row>
                </el-carousel-item></el-carousel>

        </div>
    </div>
</template>

<script>

export default {
    name: 'DataTable',
    components: {
    },
    props: {
        data: {
            type: Array,
            default: () => ([]),
        },
        header: {
            type: Array,
            default: () => ([{ title: '序号', width: 2 }, { title: '门店', width: 10 }, { title: '月销量额(元)', width: 6 }, { title: '月完成率', width: 6 }])
        }
    },
    data() {
        return {
            pageTotal: 1,
            pageSize: 8,
            total: 8,
            pageData: [],

            config: {
                index: true,
                align: ['center'],
                rowNum: 7,
                headerBGC: '#1981f6',
                headerHeight: 45,
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)'
            }
        }
    },
    watch: {
        data: {
            handler(newData) {
                if (newData.length == 0) return;
                this.initData(newData);
            },
            deep: true
        }
    },
    mounted() {
        if (this.data && this.data.length > 0)
            this.initData(this.data);
    },
    methods: {
        pageChange(currentPage) {
            console.log('pageChange', currentPage);
        },
        initData(val) {

            this.pageData = [];
            this.total = val.length;
            this.pageTotal = parseInt(this.total / this.pageSize) + 1;
            for (let i = 0; i < this.pageTotal; i++) {
                this.pageData.push({ arr: val.slice(i * this.pageSize, (i + 1) * this.pageSize) });
            }

            console.log('pageData', this.pageData);
        },
    }


}
</script>

<style lang="less" scoped>
#scroll-board {
    width: 100%;
    position: relative;
    margin-top: 1vh;
    height: 100%;
    overflow: hidden;
    background: rgba(24, 50, 148, 0.30);
    border: none;

    .topbox {
        border-radius: 8px;

    }

    .itemrow {
        height: 5.5vh;
        display: flex;
        /* 使用 Flexbox 布局 */
        align-items: center;

        /* 垂直居中 */
        &:nth-child(odd) {
            // background: linear-gradient(270deg,rgba(29,123,188,0.00), rgba(29,123,188,0.70));
            background: linear-gradient(270deg, rgba(29, 123, 188, 0.00), rgba(66, 160, 226, 0.3));
            border-image: linear-gradient(158deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 83%) 1 1;
            border-top: 1px solid;
            border-bottom: 1px solid;
        }

        // &:nth-child(even) {
        //   background-color: rgba(10, 29, 50, 0.8);
        // }
    }



    .datarow {
        height: 5.5vh;
        display: flex;
        /* 使用 Flexbox 布局 */
        align-items: center;

        /* 垂直居中 */
        &:nth-child(even) {
            background: linear-gradient(270deg, rgba(29, 123, 188, 0.00), rgba(66, 160, 226, 0.3));
        }
    }

    .sort_first {
        width: 1.5vw;
        height: 1.7vw;
        background-image: url('../img/01.png');
        background-size: 100% 100%;
    }

    .sort_sec {
        width: 1.5vw;
        height: 1.7vw;
        background-image: url('../img/02.png');
        background-size: 100% 100%;
    }

   .sort_thr {
        width: 1.5vw;
        height: 1.7vw;
        background-image: url('../img/03.png');
        background-size: 100% 100%;
    }
}
</style>